module.exports = __webpack_public_path__ + "img/symbol-hearing-signature-eg.5af05447.svg";